import { useContext } from 'react';
import { SessionContext, SessionContextInterface } from './SessionContext';

export const useSession = (): SessionContextInterface => {
  const sessionContext = useContext(SessionContext);
  if (!sessionContext) throw new Error('useAuth must be used within an SessionContextProvider');
  return sessionContext;
};
